<div class="row">
    <div class="col-xl-6">
        <div class="card card-box bg-neutral-success p-3 mb-5">
            <div class="d-flex align-items-center py-4 px-5 justify-content-between">
                <div class="pr-2">
                    <h4 class="font-size-xl font-weight-bold mb-2">Technical Support</h4>
                    <p class="opacity-6 font-size-md mb-0">
                        He lay on his armour-like back, and if he lifted his head.
                    </p>
                </div>
                <button class="btn btn-success text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Send Email</small>
                </button>
            </div>
        </div>
        <div class="card card-box bg-composed-wrapper bg-slick-carbon border-0 mb-5">
            <div class="bg-composed-img-5 bg-composed-wrapper--image"></div>
            <div class="bg-composed-wrapper--content text-light d-flex align-items-center p-5 justify-content-between">
                <div class="pr-2">
                    <h4 class="font-size-xl font-weight-bold mb-2">Technical Support</h4>
                    <p class="opacity-6 font-size-md mb-0">
                        He lay on his armour-like back, and if he lifted his head.
                    </p>
                </div>
                <button class="btn btn-success text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Send Email</small>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box bg-neutral-warning p-3 mb-5">
            <div class="d-flex align-items-center py-4 px-5 justify-content-between">
                <div class="pr-2">
                    <h4 class="font-size-xl font-weight-bold mb-2">Knowledge Base Software</h4>
                    <p class="opacity-6 font-size-md mb-0">
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem.
                    </p>
                </div>
                <button class="btn btn-warning text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Contact</small>
                </button>
            </div>
        </div>
        <div class="card card-box bg-composed-wrapper bg-vicious-stance border-0 mb-5">
            <div class="bg-composed-img-3 bg-composed-wrapper--image"></div>
            <div class="bg-composed-wrapper--content text-light d-flex align-items-center p-5 justify-content-between">
                <div class="pr-2">
                    <h4 class="font-size-xl font-weight-bold mb-2">Knowledge Base Software</h4>
                    <p class="opacity-6 font-size-md mb-0">
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem.
                    </p>
                </div>
                <button class="btn btn-danger text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Contact</small>
                </button>
            </div>
        </div>
    </div>
</div>
